const DEV_URL = 'http://localhost:10200'
const FALLBACK_PRODUCTION_URL = 'https://reabilitaretermica.eu'

function resolveProductionOrigin () {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  if (typeof self !== 'undefined' && self.location?.origin) {
    return self.location.origin
  }
  return FALLBACK_PRODUCTION_URL
}

export default process.env.NODE_ENV === 'production'
  ? resolveProductionOrigin()
  : DEV_URL
